import React from 'react'

function ManageStoreLayer() {
  return (
    <div>ManageStoreLayer</div>
  )
}

export default ManageStoreLayer